import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {CloudflareService} from "../../../services/cloudflare.service";
import * as fromStore from '../../../../../../store';
import {Store} from "@ngrx/store";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {ActivatedRoute, Router} from "@angular/router";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {FormControl, Validators} from "@angular/forms";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-edit-original-ip',
    templateUrl: './edit-original-ip.component.html',
    styleUrls: ['./edit-original-ip.component.scss'],
    standalone: false
})
export class EditOriginalIpComponent implements OnInit {

  @Input() websiteId: number;
  @Input() originalIp: string;
  @Input() sizes: { width: number, height: number };
  public originalRecord: FormControl;
  public loading: boolean;


  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _dbModalService: DbModalService,
    private _activeModal: DbActiveModal,
    private _cloudflareService: CloudflareService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this.resize([this.sizes.height, this.sizes.width]);
    this.originalRecord = new FormControl(this.originalIp, [Validators.required]);
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public confirm(): void {
      this._router.navigate([`websites/${this.websiteId}/booster/cloudflare`]);
  }

  public updateOriginalIp(): void {
    this.loading = true;
    this._cloudflareService.editDnsRecord(this.websiteId, this.originalRecord.value)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.sendEvent('Update the original server IP');
          this._store.dispatch(new fromStore.SetClodFlareOriginalRecord(
            {
              websiteId: this.websiteId,
              originalRecord: this.originalRecord.value,
            }));
          NotifierComponent.notify(new Notification('Saved successfully', NotificationType.SUCCESS));
          this._activeModal.close();
        }
        else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }

      });
  }

  public sendEvent(action: string): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  public openChat(): void {
    this._activeModal.close();
    /*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
    window['zE']('messenger', 'chat:addTags', ['open_livechat']);*/

    window['Smooch']?.open();
    /*window['zE']('messenger', 'chat:send', 'I need help with setting up Cloudflare');*/
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }


}
